import axios from 'axios';
import { number, string } from 'prop-types';
import React from 'react';
import { GoCloudDownload } from 'react-icons/go';

import FileDownloader from '../../generic/FileDownloader';
import api from '../../REST/api';

export default function DownloadButton({ id, fileName }) {
  const onGetFile = async () => {
    const newlyLoadedCreative = await api.getCreative({ id });

    const { data } = await axios.get(newlyLoadedCreative.fileUrl, {
      responseType: 'blob',
    });
    return { data, name: fileName };
  };

  return (
    <FileDownloader onGetFile={onGetFile} outline size="sm">
      <GoCloudDownload />
    </FileDownloader>
  );
}

DownloadButton.propTypes = {
  id: number.isRequired,
  fileName: string.isRequired,
};
